import React, { ReactElement } from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import Grid from '@bit/atd.web.grid'
import { createClassNames } from '../../../helpers'
import List from '../MenuList'
import Link from '../Link'
import colors from '@bit/atd.web.colors'
import { useHistory, useLocation } from 'react-router-dom'
import { contentTypes, ContentType } from 'constants/contentTypesMap'
import clsx from 'clsx'

const cx = createClassNames('HierarchicalMenu')

const useStyles = makeStyles(() =>
  createStyles({
    link: {
      background: colors.white,
      padding: '20px 0px',
      justifyContent: 'center',
      fontSize: '14px',
      color: '#67666A',
      textDecoration: 'none',
    },
    parentLink: {
      fontWeight: 600,
    },
    childLink: {
      fontWeight: 500,
    },
    linkContainer: {
      marginBottom: '10px',
    },
    linkItem: {
      display: 'flex',
    },
    count: {
      border: '1px solid #DBD9D6',
      borderRadius: '11px',
      padding: '0px 5px',
      marginLeft: '5px',
      fontWeight: 500,
    },
    active: {
      fontWeight: 600,
      borderBottom: `2px solid ${colors.brandOrange}`,
    },
  }),
)

type itemsPropType = {
  label: string
  count: number
  value?: string
  items?: (...args: { [p: string]: any }[]) => void
}[]

type PropsType = {
  refine: (item: any) => void
  createURL: (item: any) => string
  canRefine: boolean
  items: itemsPropType
  showMore: boolean
  className?: string
  limit: number
  showMoreLimit: number
  transformItems?: () => void
  index: string
}

const HierarchicalMenu = (props: PropsType) => {
  /**********************
   * PROPS
   ***********************/

  const {
    refine,
    items,
    showMore,
    limit,
    showMoreLimit,
    canRefine,
    className,
    index,
  } = props

  const classes = useStyles()
  const history = useHistory()
  const location = useLocation()

  /**********************
   * FUNCTIONS
   ***********************/
  const renderItem = (
    item: { label: string; value: any; isRefined: boolean; count: number },
    isChild: boolean,
  ): ReactElement => {
    const categoryContent: ContentType | undefined = contentTypes.find(
      ({ label, children }: ContentType) =>
        item.label === label ||
        children?.find(({ label }) => item.label === label),
    )

    const url = isChild
      ? `/search/${index}${location.search}`
      : //@ts-ignore
        `/search/${categoryContent?.index}${location.search}`
    return (
      <Link
        className={clsx(classes.link, {
          [classes.childLink]: isChild,
          [classes.parentLink]: !isChild,
        })}
        onClick={() => {
          if (isChild) {
            refine(item.value)
          } else {
            history.push(url)
          }
        }}
        href={url}
      >
        <Grid className={classes.linkContainer} container>
          <span
            className={clsx({
              [classes.active]: item.isRefined,
            })}
          >
            {item.label}
          </span>

          {/*
          @todo do not delete, temporarily hidden while we try to align counts between master and other index
          <span className={classes.count}>{item.count}</span>
          */}
        </Grid>
      </Link>
    )
  }

  /**********************
   * RENDER
   ***********************/
  return (
    <List
      renderItem={renderItem}
      cx={cx}
      items={items}
      showMore={showMore}
      limit={limit}
      showMoreLimit={showMoreLimit}
      canRefine={canRefine}
      className={className}
    />
  )
}

HierarchicalMenu.defaultProps = {
  className: '',
}

export default HierarchicalMenu
